import { createSelector } from '@ngrx/store';
import find from 'lodash/find';

import { getCitation } from './get.citations';
import { NumberedCitation } from '../../models';

export const getCopiedNumberedCitation = createSelector(
  getCitation,
  ({ copiedNumberedCitationId, references }): NumberedCitation | undefined =>
    find(references, { citationId: copiedNumberedCitationId })
);
